// 中文版
export default {

  home: '首页',
  aboutUs: '关于我们',
  productsAndServices: '产品与服务',
  projectCases: '项目案例',
  contactUs: '📩 联系我们',
  contactUs2: '联系我们',
  scrollDown: '鼠标滚动',
  companyName: 'Ocean Harmony Trade Co., Ltd',
  companyIntro: '公司简介',
  brandStory:'品牌故事',
  developmentHistory: '发展历程',
  corporateCulture: '企业文化',
  qualificationsAndHonors: '资质荣誉',
  partners: '合作伙伴',
  customer: '客户',
  domesticNetwork: '国内网络',
  overseasNetwork: '海外网络',
  businessOutlets: '经营网点',
  fullCategoryTransportService: '全品类运输服务',
  oneStopSupplyChainService: '“一站式”供应链服务',
  mainEngineeringMaterialsProducts: '主营工程物资产品',
  logisticsBusiness: '物流业务',
  materialsBusiness: '物资业务',
  fullSupplyChainBusiness:'全程供应链业务',
  aboutOceanHarmony: '了解 Ocean Harmony',
  historyAndEvolution: '历史沿革 (2024 ~ 至今)',
  companyHonors: '公司荣誉',
  address: '地址',
  phone: '电话',
  email: '邮箱',
  send: '发送',
  weChatQRCode: '微信公众号二维码',
  scanToFollowUs: '扫一扫关注我们',
  contact: '随时发送您的咨询！',
  mondayToFriday: '周日-周四',
  leaveMessage: '留言',
  subject: '主题',
  nickname: '昵称',
  companyTopName: "中成集团",
  transportation: "中成运输",
  copyright: "版权所有",
  companyTopTitle: "中成国际运输深圳有限公司",
  projectDetail:'项目详情',

  enterYourName: '请输入您的昵称',
  enterYourEmail: '请输入您的邮箱',
  enterYourPhone: '请输入您的电话',
  enterSubject: '请输入主题',
  enterMessageContent: '请输入留言内容',
  enterValidEmail: '请输入有效的邮箱地址',
  messageContentAtLeast10: '留言内容至少 10 个字符',
  nameLengthBetween2And30: '姓名长度在 2 到 30 个字符',
  formSubmitSuccess: '发送成功，感谢您的来信！',
  completeFormBeforeSubmitting: '请完善表单信息后提交',
  mainTilte: '深耕工程项目领域，围绕工程项目特性供应以下主营物资产品',
  ViewDetails: '查看详细',
  Loading: '加载中...',
  companyCoverage: "国内<span class=\"map-top\">&nbsp;13&nbsp;</span>家公司覆盖全国沿线主要港口城市",
  businessOutletsTitle1:"Ocean Harmony，当前已在海外设立<span class='w-map-top'>&nbsp;9&nbsp;</span>个直管驻点",
  businessOutletsTitle2:"深耕非洲和东南亚地区超过<span class='w-map-top'>&nbsp;14&nbsp;</span>年",
  qayimatAlmuntajat:"产品清单",
  LanguageMessage:"设置语言成功!",
  WHATSAPP:'WHATSAPP'
};